import React from "react";
import { User } from "lucide-react";

const ProfileSubPage = ({ formData, setFormData, handleUpdateProfile, updating }) => {
  return (
    <div className="max-w-3xl mx-auto bg-white dark:bg-[#0B0F19] border border-slate-200 dark:border-slate-900 rounded-3xl p-6 md:p-8 shadow-xl">
      <div className="border-b border-slate-200 dark:border-slate-800 pb-5 mb-6">
        <h2 className="text-xl font-black text-slate-800 dark:text-white flex items-center gap-2">
          <User className="w-5 h-5 text-sky-500 dark:text-sky-400" />
          Profile Settings
        </h2>
        <p className="text-slate-500 text-xs mt-1">Update your professional details and bank settlement configurations.</p>
      </div>

      <form onSubmit={handleUpdateProfile} className="space-y-5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="space-y-2">
            <label className="block text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest">Full Name</label>
            <input 
              type="text" 
              value={formData.fullName}
              onChange={(e) => setFormData({...formData, fullName: e.target.value})}
              className="w-full px-4 py-3 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl focus:border-sky-500 focus:outline-none focus:ring-0 text-slate-800 dark:text-slate-200 text-sm font-medium transition-all placeholder-slate-400 dark:placeholder-slate-700"
              required
            />
          </div>
          <div className="space-y-2">
            <label className="block text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest">Email Address</label>
            <input 
              type="email" 
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="w-full px-4 py-3 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl focus:border-sky-500 focus:outline-none focus:ring-0 text-slate-800 dark:text-slate-200 text-sm font-medium transition-all placeholder-slate-400 dark:placeholder-slate-700"
              required
            />
          </div>
          <div className="space-y-2">
            <label className="block text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest">Phone Number</label>
            <input 
              type="tel" 
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              className="w-full px-4 py-3 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl focus:border-sky-500 focus:outline-none focus:ring-0 text-slate-800 dark:text-slate-200 text-sm font-medium transition-all placeholder-slate-400 dark:placeholder-slate-700"
              required
            />
          </div>
          <div className="space-y-2">
            <label className="block text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest">Settlement Bank</label>
            <input 
              type="text" 
              value={formData.bank}
              onChange={(e) => setFormData({...formData, bank: e.target.value})}
              className="w-full px-4 py-3 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl focus:border-sky-500 focus:outline-none focus:ring-0 text-slate-800 dark:text-slate-200 text-sm font-medium transition-all placeholder-slate-400 dark:placeholder-slate-700"
              required
            />
          </div>
          <div className="md:col-span-2 space-y-2">
            <label className="block text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest">Settlement Account Number</label>
            <input 
              type="text" 
              value={formData.accountNumber}
              onChange={(e) => setFormData({...formData, accountNumber: e.target.value.replace(/\D/g, "")})}
              maxLength="10"
              className="w-full px-4 py-3 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl focus:border-sky-500 focus:outline-none focus:ring-0 text-slate-800 dark:text-slate-200 text-sm font-medium transition-all placeholder-slate-400 dark:placeholder-slate-700"
              required
            />
          </div>
        </div>
        
        <div className="pt-4 border-t border-slate-200 dark:border-slate-800 flex justify-end">
          <button 
            type="submit" 
            disabled={updating}
            className="px-8 py-3.5 bg-gradient-to-r from-sky-500 to-indigo-600 hover:from-sky-400 hover:to-indigo-500 text-white font-extrabold text-xs uppercase tracking-wider rounded-xl shadow-lg shadow-sky-500/10 transition-all duration-300 disabled:opacity-70"
          >
            {updating ? "Saving Details..." : "Save Profile Changes"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProfileSubPage;
